import { render, staticRenderFns } from "./ConfigTestesResponsavel.vue?vue&type=template&id=4c9877c2"
import script from "./ConfigTestesResponsavel.vue?vue&type=script&lang=js"
export * from "./ConfigTestesResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports